export const faqs = [
  {
    q: "吃瓜前排的内容都是从哪里来的？",
    a: "内容主要来自三个渠道：公开赛事回放、现场观众的投稿，以及选手赛后的公开采访。所有素材在整理时会标注来源类型，涉及个人评价的部分我们会回到画面本身，不做二次演绎。",
  },
  {
    q: "为什么有些片段只写过程，不放视频？",
    a: "有些素材涉及版权或当事人意愿，我们会用文字还原过程而不是直接嵌入视频。文字复盘反而能更完整地交代前因后果，避免只剩十几秒的断章片段被反复传播。",
  },
  {
    q: "选美吃瓜会不会对选手造成困扰？",
    a: "这是我们在选材时最谨慎的一点。涉及私人关系、家庭信息、未公开经历的片段，即使在现场被拍到，我们也不会收录。我们只围观公开舞台上已经发生的事。",
  },
  {
    q: "更新频率是怎样的？",
    a: "赛事密集期通常每周更新三到五篇，淡季会转为栏目复盘与往期名场面整理。订阅吃瓜情报后，新内容上线会直接推送到你的邮箱。",
  },
  {
    q: "可以投稿自己拍到的现场片段吗？",
    a: "可以，欢迎通过页面下方的联系方式把素材发给我们。投稿时请尽量说明时间、赛事名称和当时的完整语境，方便我们核对后整理成有阅读价值的内容。",
  },
  {
    q: "为什么同一场比赛会出现在不同栏目里？",
    a: "因为一次直播事故往往同时包含翻车、尴尬和搞笑三重属性。我们会按最突出的那一面归入主栏目，再在文章末尾做相关推荐，避免同一素材被重复拆成多篇。",
  },
];